import React from 'react';
import { flattenRichText } from 'utils/richTextUtils';
import Helmet from 'react-helmet';
import parse from 'html-react-parser';
import { EmbedContainer } from './styles';
import { getValue, separateScriptTags } from '../../../../../utils/richTextUtils';

const RichTextEmbed = ({ fields, ...otherProps }) => {
  const { embedCode, displayCode } = flattenRichText(fields) || {};
  if (!embedCode) {
    return null;
  }

  const embedCodeToRender = getValue(JSON.parse(embedCode?.raw), 'value');

  if (displayCode === 'Head') {
    return <Helmet>{parse(embedCode)}</Helmet>;
  }

  const { html, js } = separateScriptTags(embedCodeToRender);

  return (
    <>
      <EmbedContainer
        {...otherProps}
        dangerouslySetInnerHTML={{ __html: html }}
        className="rich-text-embed"
      />
      {js && js.map((script) => <Helmet script={[{ innerHTML: script }]} />)}
    </>
  );
};

export default RichTextEmbed;
